<template>
  <div class="report-params" :style="{maxWidth: oneLineNumber? oneLineNumber*375 + 'px':'100%'}"
       :class="{'report-params-inForm': inForm}"
  >
    <el-form ref="form" :model="valueClone" class="form" :label-width="labelWidth+'px'" :label-position="labelPosition" @submit.native.prevent>
      <div class="main-form-wrapper">
        <div
          class="report-params-item"
          :class="[{'is-hidden':item.isHidden, 'is-report': !inForm}, item.inputModel, { 'isBlock': isBlock }]"
          v-for="(item, $index) in paramsModelClone"
          v-show="showItem($index, item, paramsModelClone.length)"
          :key="$index"
        >
          <component
            :is="getComponentName(item)"
            ref="formComponents"
            :code="code"
            :inForm="inForm"
            @vaildate="validateFunction"
            v-model="valueClone[item.name]"
            :nowTimeStamp="nowTimeStamp"
            v-bind="item"
            :formData="formData"
          ></component>
        </div>
      </div>
      <div  v-if="isShowArrow()">
        <div class="show-more-wrapper"
          @click="showAllParams"
        >
          <i
            class="el-icon-arrow-down show-more-arrow"
            :class="{'is-open': showAll}"
          ></i>
        </div>
      </div>
      <div
        class="sub-form-wrapper"
        v-if="subForms && subForms.length > 0"
      >
        <template
          v-for="(subForm, $index) in subForms"
        >
          <table
            class="sub-form-table"
            v-if="subForm.layout === 'table'"
            :key="$index"
          >
            <thead>
            <tr>
              <th
                class="operator-th"
              >
                  <button style="width: 60px" @click="addSubFormRow($index)">
                    新增
                  </button>
              </th>
              <th
                class="sub-form-table-th"
                v-for="(component, $idx) in subForm.items"
                v-if="!component.isHidden"
              >
                {{component.title}}
              </th>
            </tr>
            </thead>
            <tbody>
              <tr
                v-for="(row, $idxR) in valueClone.subForms[$index]"
              >
                <td style="border-bottom: 1px solid #42b983">
                  <button style="width: 60px;" @click="removeRow($index, $idxR)">
                    删除
                  </button>
                </td>
                <td
                  v-for="(value, key) in row"
                  class="sub-form-table-row-td"
                  v-if="!isShowInSubForm($index, key)"
                >
                  <component
                    :is="getSubFormComponentName($index, key)"
                    ref="subFormComponents[key]"
                    :code="code"
                    v-model="row[key]"
                    v-bind="retItem($index, key)"
                    :formData="formData"
                    :hasLabel="false"
                  ></component>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </div>
    </el-form>
  </div>
</template>
<script>
  import { inputModel } from '../../../utils/report.js'
  import input from '@/components/FromBase/input.vue'
  import text from '@/components/FromBase/text/index.vue'
  import textArea from '@/components/FromBase/textArea.vue'
  import select from '@/components/FromBase/select.vue'
  import feSwitch from '@/components/FromBase/switch.vue'
  import checkbox from '@/components/FromBase/checkbox.vue'
  import radio from '@/components/FromBase/radio.vue'
  import datePicker from '@/components/FromBase/datePicker.vue'
  import doubleDatePicker from '@/components/FromBase/doubleDatePicker.vue'
  import commonTree from '@/components/FromBase/commonTree.vue'
  import range from '@/components/FromBase/range.vue'
  import inputDia from '@/components/FromBase/inputDia.vue'
  import timeLine from '@/components/FromBase/timeLine.vue'
  import uploadCdn from '@/components/FromBase/uploadCdn.vue'
  import area from '@/components/FromBase/area.vue'
  import multipleReport from '@/components/FromBase/multReport.vue'
  import singleReport from '@/components/FromBase/singleReport.vue'
  import password from '@/components/FromBase/password.vue'
  import weekPicker from '@/components/FromBase/weekPicker.vue'
  import monthPicker from '@/components/FromBase/monthPicker.vue'
  import areaSelectGroup from '../../../components/FromBase/areaSelectGroup.vue'
  // import _ from 'lodash'
/* eslint-disable */
  import helpService from '@/utils/manager'
  import { mapGetters } from 'vuex'
  let config = null
  try {
    config = require('@/_app/' + process.env.PROJECT + '/src/config/index').default
    console.log(config)
  } catch (e) {
    console.warn('config')
  }
  export default {
    name: 'report-params',
    components: {
      // 'fe-text': text,
      'fe-input': input,
      'fe-text-only': text,
      'fe-text': textArea,
      'fe-select': select,
      'fe-switch': feSwitch,
      'fe-checkbox': checkbox,
      'fe-radio': radio,
      'fe-single-date-picker': datePicker,
      'fe-double-date-picker': doubleDatePicker,
      'fe-common-tree': commonTree,
      'fe-range': range,
      'fe-inputDia': inputDia,
      'fe-time-line': timeLine,
      'fe-uploadCdn': uploadCdn,
      'fe-area': area,
      'multiple-report': multipleReport,
      'single-report': singleReport,
      'fe-password': password,
      'fe-weekPicker': weekPicker,
      'fe-monthPicker': monthPicker,
      'fe-area-select-group': areaSelectGroup
    },
    data(){
      return{
        isScripted: false
      }
    },
    props: {
      isBlock: {
        type: Boolean | undefined
      },
      code: String,
      resouceType: String,
      script: String,
      paramsModel: {
        type: Array
      },
      value: Object,
      formData: {
        type: Boolean
      },
      labelWidth:{
        type: Number,
        default: 120
      },
      inForm: {
        type: Boolean,
        default: false
      },
      subForms: {
        type: Array
      },
      autoFocus: {
        type: Boolean,
        default: false
      },
      loadingData: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapGetters([
        'width'
      ]),
     
      oneLineNumber(){
        if(this.inForm){
          return null
        }
        return config.reportParamsNumber
      },
      showNumber() {
        if(config.reportParamsNumber){
          return config.reportParamsNumber
        }
        if (process.env.PROJECT === 'outlet'){
          return Math.floor((this.$store.state.app.width) / 350) * 1
        }
        else{
           return Math.floor((this.$store.state.app.width) / 340) * 1
        }
        // alert(Math.floor((this.$store.state.app.width) / 298) * 1)
      }
    },
    mounted() {
      console.log(this.subForms)
      if (this.autoFocus) {
        if (this.$refs.formComponents && this.$refs.formComponents.length > 0) {
          const hasFocus = this.$refs.formComponents.filter(item => {
            if (item.focus) {
              return true
            }
          })
          hasFocus[0].focus()
        }
      }
      // if(config && config.showMoreParams){
      //   this.showAllParams()
      // }
      this.$emit('ready-height', this.$el.offsetHeight)
      this.$eventBus.$emit('showColumnExpFlag', (!this.inForm && (this.paramsModelClone && this.paramsModelClone.length > this.showNumber)))
    },
    beforeMount() {
      const helpSpace = window.helpSpace || {}
      if (!helpSpace[this.code]) {
        helpSpace[this.code] = {}
      }
      window.helpSpace = helpSpace
      helpSpace[this.code]['form'] = helpService.getForm(this)
      if (!this.$route.query || !this.$route.query.method || this.$route.query.method !== 'update') {
        this.dealAllScripts()
      }
    },
    beforeUpdate() {
      // 为tab页面定制
      const helpSpace = window.helpSpace || {}
      if (!helpSpace[this.code]) {
        helpSpace[this.code] = {}
      }
      window.helpSpace = helpSpace
      helpSpace[this.code]['form'] = helpService.getForm(this)
      if (!this.$route.query || !this.$route.query.method || this.$route.query.method !== 'update') {
        this.dealAllScripts()
      }
    },
    data() {
      // 获取当前的一个时间戳  时间范围组件新添加属性
      this.nowTimeStamp = new Date().getTime()
      this.labelPosition = 'right'
      this.inputModel = inputModel
      this.levelLength = 1
      this.areaIndex = -1
      this.hiddenLength = 0
      return {
        showAll: false,
        valueClone: {},
        paramsModelClone: [],
        backupValue: {},
        vaildateFlag: true,
        subFormsClone: [],
        dynamicWatches: []
      }
    },
    watch: {
      loadingData: {
        handler(val) {
          if (!val) {
            if (this.$route.query && this.$route.query.method === 'update') {
              this.$nextTick(() => {
                this.dealAllScripts()
              })
            }
          }
        }
      },
      value: {
        handler(val) {
          this.valueClone = _.cloneDeep(val)
          console.log(this.valueClone)
          if (_.isEmpty(this.backupValue)) {
            this.backupValue = _.cloneDeep(val)
          }
        },
        deep: true,
        immediate: true
      },
      paramsModel: {
        handler(val) {
          if (!val) return
          this.paramsModelClone = _.cloneDeep(val)
          const newArray = this.paramsModelClone.filter((item, index) => {
            if (item.inputModel === 'area-select') {
              this.areaIndex = index
              return true
            }
          })
          const hiddenArray = this.paramsModelClone.filter((item, index) => {
            if (item.isHidden) {
              return true
            }
          })
          this.hiddenLength = hiddenArray.length
          if (newArray.length > 0) {
            this.levelLength = newArray[0].level ? newArray[0].level.length : 3
          }
        },
        deep: true,
        immediate: true
      },
      subForms: {
        handler(val) {
          this.subFormsClone = _.cloneDeep(val)
        },
        deep: true,
        immediate: true
      }
    },
    created() {
      this.$bus.$on('submit' + this.resouceType + this.code, this.confirm)
      if(config && config.showMoreParams){
        this.showAllParams()
      }
    },
    beforeDestroy() {
      this.dynamicWatches.forEach(unwatch => {
        unwatch()
      })
      this.$bus.$off('submit' + this.resouceType + this.code)
    },
    methods: {
      isShowArrow() {
        if (!this.inForm) {
          if (this.areaIndex !== -1) {
            if (this.showNumber <= this.areaIndex) {
              return true
            }
            if (this.paramsModelClone.length - this.hiddenLength > this.showNumber + 2) {
              return true
            } else {
              return false
            }
          } else {
            return this.paramsModelClone.length - this.hiddenLength > this.showNumber
          }
        } else {
          return false
        }
        // if (!this.inForm && (this.paramsModelClone && this.paramsModelClone.length > this.showNumber)) {
        //   return true
        // } else {
        //  return false
        // }
      },
      showItem($index, item, length) {
        if (this.showAll) {
          return true
        }
        if (this.inForm) {
          return true
        }
        if (this.areaIndex !== -1) {
          if (this.showNumber - $index > 1 && $index === length - 1) {
            return true
          }
          if (this.areaIndex === $index) {
            return false
          }
          if (this.showNumber > $index - this.hiddenLength) {
            return true
          } else {
            return false
          }
        } else {
          if (this.showNumber > $index - this.hiddenLength) {
            return true
          } else {
            return false
          }
        }
      },
      dealAllScripts() {
        // const script = 'const form = window.helpSpace.hsc_org_list_edit.form; form.addListener([\'orgMaker\'], function(value) {form.setValue(\'orgBrand\', {}); form.setValue(\'orgSubBrand\', {})}, true, false);form.addListener([\'orgBrand\'], function(value) {form.setValue(\'orgSubBrand\', {})}, true, false)'
        if(!this.isScripted){
          helpService.dealScript(this.code, this.script)
          this.isScripted = true
        }
        helpService.dealCss(this.code, this.css)
      },
      validateFunction(flag) {},
      beforSubmit() {
        const components = this.$refs.formComponents
        this.vaildateFlag = true
        if (components && components.length > 0) {
          components.forEach((item) => {
            const name = item.$attrs['inputModel'] || item.name
            // if (item.$v && name !== 'single-date-picker' && name !== 'double-date-picker' && name !== 'month-date-picker' && name !== 'month-date-picker' && name !== 'week-date-picker') {
            if (item.$v  && name !== 'double-date-picker' && name !== 'month-date-picker' && name !== 'month-date-picker' && name !== 'week-date-picker') {
              item.$v.defaultValue && item.$v.defaultValue.$touch()
              if (item.$v.defaultValue.$error) {
                this.vaildateFlag = false
                if(!this.inForm){
                  this.$message.error(item.errorMessage || '请检查查询条件')
                  return
                }
              }
            } else if (name === 'area-select') {
              if (item.required) {
                if (item.value.length === 0) {
                  this.vaildateFlag = false
                  this.$nextTick(() => {
                    this.$message.error('请选择区域')
                  })
                }
              }
            }
          })
        }
      },
      confirm(event) {
        // 应该是查询调用这里
        return new Promise((resolve, reject) => {
          this.vaildateFlag = true
          this.beforSubmit()
          this.$nextTick(() => {
            if (this.vaildateFlag) {
              this.$emit('input', this.valueClone)
              this.$nextTick(() => {
                resolve({
                  value: this.valueClone,
                  flag: this.vaildateFlag
                })
              })
            }
          })
        })
      },
      removeRow(subFormIndex, rowIndex) {
        const subFormValue = this.valueClone.subForms[subFormIndex]
        console.log('删除子表单：' + subFormIndex)
        subFormValue.splice(rowIndex, 1)
      },
      retItem(index, name) {
        const subForm = this.subForms[index].items
        let retItem = null
        subForm.forEach((item) => {
          if (item.name === name) {
            retItem = item
          }
        })
        return retItem
      },
      isShowInSubForm(index, name) {
        const subForm = this.subForms[index].items
        let componentName = null
        subForm.forEach((item) => {
          if (item.name === name) {
            componentName = item
          }
        })
        return componentName.isHidden
      },
      getSubFormComponentName(index, name) {
        const subForm = this.subForms[index].items
        let componentName = null
        subForm.forEach((item) => {
          if (item.name === name) {
            const inputModel = item.inputModel
            componentName = this.inputModel[inputModel]
          }
        })
        return componentName
      },
      addSubFormRow(index) {
        const subForm = this.subForms[index]
        const items = subForm.items
        const retObj = {}
        items.forEach((item) => {
          const value = item.value || ''
          const name = item.name
          retObj[name] = value
        })
        this.valueClone.subForms[index].push(retObj)
      },
      getComponentName(item) {
        const inputModel = item.inputModel
        const componentName = this.inputModel[inputModel]
        return componentName
      },
      getSendValue(name) {
        return this.valueClone[name]
      },
      reset(isDialog) {
        // this.backupValue = {}
        this.$emit('clearReport')
        console.log(this.backupValue)
        this.valueClone = _.cloneDeep(this.backupValue)
        if (!isDialog) {
          this.$eventBus.$emit('clearDefaultValueDia')
        }
      },
      showAllParams() {
        this.showAll = !this.showAll
      }

    }
  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  report-params-inForm{
    flex:1;
  }
  .report-params {
    display: flex;
    flex-direction: row;
    margin-left: 20px;
    margin-right: 20px;
    flex-wrap: wrap;
    position: relative;
    // margin-bottom: 15px;
    .form {
      width: 100%;
      display: flex;
      flex-direction: column;
      // border: 1px solid #e6e6e6;
      border-left: none;
      border-right: none;
      padding:5px 0;
      .main-form-wrapper{
        display: flex;
        flex-wrap: wrap;
        .report-params-item{
          /*&:nth-child(n+4) {*/
             /*margin-top: 0px;*/
             /*margin-bottom: -3px;*/
           /*}*/
        }
      }
      .show-more-wrapper{
        width: 40px;
        height: 15px;
        line-height: 15px;
        background: #ebeef5;
        position: absolute;
        left: calc(50% - 20px);
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
        cursor: pointer;
        bottom:-15px;
        z-index: 11;
        text-align: center;
        .show-more-arrow{
          transition: .3s ease-in-out;
          &.is-open{
            transform: rotate(-180deg);
          }
        }
      }
      .report-params-item{
        width: 298px;
        float: left;
        margin-bottom: 12px;
        &.is-report{
          margin-bottom: 0px;
        }
        &.is-hidden{
          display: none;
        }
        // height: 45px;
        &.area-select{
           width: auto !important;
           margin-bottom: 0px;
         }
      }
      .sub-form-wrapper{
        overflow: auto;
        flex: 1;
        .sub-form-table{
          font-family: Helvetica Neue, Arial, sans-serif;
          font-size: 14px;
          color: #444;
          width:100%;
          border: 2px solid #42b983;
          border-radius: 3px;
          /*background-color: #fff;*/
          overflow: auto;
          flex: 1;
          .sub-form-table-row-td{
            border-bottom: 1px solid #42b983;
            border-left: 1px solid #42b983;
          }
          .operator-th {
            width: 60px;
            cursor: pointer;
            border-bottom: 1px solid #42b983;
            button: {
              width: 60px;
              cursor: pointer;
            }
          }
          .sub-form-table-th {
            /*background-color: #42b983;*/
            cursor: pointer;
            min-width: 178px;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            border-left: 1px solid #42b983;
            border-bottom: 1px solid #42b983;
          }
        }
      }
    }
  }
  /*class="item.inputModel==='area'? 'w-full':''" */
  .isBlock,
  .area{
    width: 100% !important;
  }

</style>



// WEBPACK FOOTER //
// src/views/report/components/reportParams.vue